import {
  Box,
  ImageList,
  ImageListItem,
  // Stack,
  styled,
  Typography,
} from '@mui/material'
import React from 'react'
import '../../styles/about.css'

const TeamSection = styled('Box')({
  // backgroundColor: 'green',
  display: 'flex',
  width: '80%',
  margin: '2rem auto',
})

const About = () => {
  return (
    <>
      <div className='about-us-container'>
        <div className='about-heading'>
          <h1>About Us </h1>
        </div>
        <div className='about-intro'>
          <section>
            <p>About us.</p>
            <p>Our Team.</p>
            <p>Our members.</p>
          </section>
          <section>
            <p>
              Lorem ipsum dolor sit amet consectetur adipisicing elit. Deserunt,
              repudiandae nesciunt reprehenderit nobis laboriosam error,
              reiciendis labore ut delectus, quisquam repellendus eum rerum!
              Necessitatibus quas perspiciatis maiores id quibusdam inventore
              perferendis libero eligendi, dolores ullam facere enim, amet
              tempora quo blanditiis deleniti. Fuga ea eaque consequatur
              consequuntur porro aspernatur inventore!
            </p>
            <p>
              Lorem ipsum, dolor sit amet consectetur adipisicing elit. Nemo
              tempore vero aliquam? Molestias alias, amet quod mollitia repellat
              dolores tempore quam nobis? Est laborum aut tempore quidem,
              pariatur vel, animi odio veniam tenetur, fugit iure necessitatibus
              nihil perspiciatis nulla nemo minus ipsam aspernatur odit illo
              consequuntur modi rerum ipsum quaerat aperiam. Similique
              voluptates excepturi quae nihil quo voluptatem temporibus
              reprehenderit, est nostrum quia nulla quod quasi doloremque
              laboriosam saepe autem eum maiores repudiandae, asperiores ut!
              Iure obcaecati nesciunt tempora libero quisquam nam explicabo?
              Itaque corrupti deleniti eos similique quam rerum sit ex cumque
              fugiat molestias dicta natus, est dolorum incidunt!
            </p>
          </section>
        </div>
      </div>
      <div className='about-image-container'></div>

      <div className='motivation-sec'>
        <section>
          <h2>
            " Our Work does makes sense only if it is a faithfull moment of its
            time."
          </h2>
          <p>Jean-Philipe</p>
        </section>
        <section>
          <img
            src='https://images.pexels.com/photos/716276/pexels-photo-716276.jpeg?auto=compress&cs=tinysrgb&w=600'
            alt='tutor teaching'
            width={'100%'}
          />
        </section>
      </div>

      <TeamSection>
        <Box sx={{ width: '50%', height: 450, overflowY: 'scroll' }}>
          <ImageList variant='masonry' cols={3} gap={8}>
            {itemData.map((item) => (
              <ImageListItem key={item.img}>
                <img
                  src={`${item.img}?w=248&fit=crop&auto=format`}
                  srcSet={`${item.img}?w=248&fit=crop&auto=format&dpr=2 2x`}
                  alt={item.title}
                  loading='lazy'
                />
              </ImageListItem>
            ))}
          </ImageList>
        </Box>
        <Box flex={1} p={2} fontFamily='sans-serif' position={'relative'}>
          <Typography variant='h2' component='h1'>
            Our Team
          </Typography>
          <Typography variant='body2' gutterBottom>
            Lorem, ipsum dolor sit amet consectetur adipisicing elit.
            Architecto, dignissimos necessitatibus assumenda eligendi sapiente
            sequi modi eum fuga illo libero.
          </Typography>
          <Typography variant='body2'>
            Lorem, ipsum dolor sit amet consectetur adipisicing elit.
            Architecto, dignissimos necessitatibus assumenda eligendi sapiente
            sequi modi eum fuga illo libero. Lorem ipsum, dolor sit amet
            consectetur adipisicing elit. Officia soluta reiciendis ut quod
            atque exercitationem autem tenetur asperiores blanditiis sed?
          </Typography>
          <ul className='sponsors-sec'>
            <li>
              <h1 style={{ fontSize: 56, margin: 0 }}>20</h1>
              <p style={{ margin: 0 }}>tutors</p>
            </li>
            <li>
              <h1 style={{ fontSize: 56, margin: 0 }}>600</h1>
              <p style={{ margin: 0 }}>students</p>
            </li>
            <li>
              <h1 style={{ fontSize: 56, margin: 0 }}>10</h1>
              <p style={{ margin: 0 }}>sponsors</p>
            </li>
          </ul>
        </Box>
      </TeamSection>
    </>
  )
}

export default About

const itemData = [
  {
    img: 'https://images.pexels.com/photos/3184642/pexels-photo-3184642.jpeg?auto=compress&cs=tinysrgb&w=600',
    title: 'Bed',
  },
  {
    img: 'https://images.pexels.com/photos/3771074/pexels-photo-3771074.jpeg?auto=compress&cs=tinysrgb&w=600',
    title: 'Books',
  },
  {
    img: 'https://images.pexels.com/photos/4339798/pexels-photo-4339798.jpeg?auto=compress&cs=tinysrgb&w=600',
    title: 'Sink',
  },
  {
    img: 'https://images.pexels.com/photos/5905486/pexels-photo-5905486.jpeg?auto=compress&cs=tinysrgb&w=600',
    title: 'Kitchen',
  },
  {
    img: 'https://images.pexels.com/photos/6929219/pexels-photo-6929219.jpeg?auto=compress&cs=tinysrgb&w=600',
    title: 'Blinds',
  },
  {
    img: 'https://images.pexels.com/photos/5699485/pexels-photo-5699485.jpeg?auto=compress&cs=tinysrgb&w=600',
    title: 'Chairs',
  },
  {
    img: 'https://images.pexels.com/photos/5905483/pexels-photo-5905483.jpeg?auto=compress&cs=tinysrgb&w=600',
    title: 'Laptop',
  },
  {
    img: 'https://images.pexels.com/photos/8653942/pexels-photo-8653942.jpeg?auto=compress&cs=tinysrgb&w=600',
    title: 'Doors',
  },
  {
    img: 'https://images.pexels.com/photos/1040880/pexels-photo-1040880.jpeg?auto=compress&cs=tinysrgb&w=600',
    title: 'Coffee',
  },
  {
    img: 'https://images.pexels.com/photos/1559486/pexels-photo-1559486.jpeg?auto=compress&cs=tinysrgb&w=600',
    title: 'Storage',
  },
  // {
  //   img: 'https://images.unsplash.com/photo-1597262975002-c5c3b14bbd62',
  //   title: 'Candle',
  // },
  // {
  //   img: 'https://images.unsplash.com/photo-1519710164239-da123dc03ef4',
  //   title: 'Coffee table',
  // },
]
